import { render, staticRenderFns } from "./MilkType.vue?vue&type=template&id=2b1d935a"
import script from "./MilkType.vue?vue&type=script&lang=js"
export * from "./MilkType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports